import { Button } from "antd";
import clsx from "clsx";
import "./supervision-notifications-action.scss";
import { FilterVariants } from "@/features/supervision-cards-list";

const getFilterDisplayName = (filter: FilterVariants) => {
  if (filter === "all") return "Все";
  if (filter === "archive") return "Архив";  
  if (filter === "important") return "Важные";
  
  return (filter as string).replace(/_/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase());
};

export const SupervisionNotificationsAction = ({
  filterVariantsArray,
  currentFilter,
  updateFilter,
  openModal,
}: {
  filterVariantsArray: FilterVariants[];
  currentFilter: string;
  updateFilter: (filter: FilterVariants) => void;
  openModal: () => void;
}) => {
  return (
    <div className="supervision-notifications-action">
      <div className="supervision-notifications-action__filters">
        {filterVariantsArray.map((filter) => (
          <div
            key={filter}
            onClick={() => updateFilter(filter)}
            className={clsx("supervision-notifications-action__filter-item", currentFilter === filter && "supervision-notifications-action__filter-item--active")}
          >
            {getFilterDisplayName(filter)}
          </div>
        ))}
      </div>
      <Button type="link" onClick={openModal}>
        Создать пакет документов
      </Button>
    </div>
  );
};

